/**
 * @mixin
 */
module.exports = {
  props: {
    /** v-model选中项绑定值 */
    modelValue: {
      type: [String, Number],
      default: null,
      required: true,
    },
    /** 占位文字 */
    placeholder: {
      type: String,
      default: "请选择",
    },
    /** 	通过 options 自定义节点
     * @values [{value, label}]
     */
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 是否多选
     * @values true / false
     */
    multiple: {
      type: Boolean,
      default: false,
    },
    /** 是否禁用
     * @values true / false
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /** 组件是否可筛选
     * @values true / false
     */
    filterable: {
      type: Boolean,
      default: false,
    },
    /** 是否可以清空选项
     * @values true / false
     */
    clearable: {
      type: Boolean,
      default: true,
    },
    /** 用于请求options的接口地址 */
    url: {
      type: String,
      default: null,
    },
    /** 请求options接口需要传的参数 */
    params: {
      type: Object,
      default: null,
    },
    /** 用于使用接口请求数据时，将后台返回的字段转换成label、value
			  {
				id: "value",
				name: "label",
			  }
			  id、name为后台接口返回的数据
		   */
    field: {
      type: Object,
      default: null,
    },
  },
  emits: {
    /** 点击右上角按钮时触发
     * @event changeCheck
     * @param {string} value 选中值的val
     * @param {object} option 目前的选中值
     */
    changeCheck: null,
  },
};
